import { hasValue, isEmptyNumber, minLength, positiveInt } from 'common/validations/field';
import i18n from 'i18n';

const defaultSessionTypeFormValidations = (values) => {
  const errors = {};

  if (!hasValue(values.name)) {
    errors.name = i18n.t('emptyField', { ns: 'validations' });
  }

  if (!minLength(values.name, 2)) {
    errors.name = i18n.t('minLength', { length: '2', ns: 'validations' });
  }

  if (isEmptyNumber(values.price)) {
    errors.price = i18n.t('emptyField', { ns: 'validations' });
  }

  if (!positiveInt(values.price)) {
    errors.price = i18n.t('positiveInteger', { ns: 'validations' });
  }

  return errors;
};

export default defaultSessionTypeFormValidations;
